/*
Supports 2 scenarios:
  1. Countdown counts every day to specific time (Specify time in UTC)
  2. Countdown counts to custom date & time (Specify time in UTC)

@Config : 
    {
      id: "yourID", -> targets [data-countdown="yourID"]
      to: {
        "default": "14:00", -> UTC Time [Scenario #1][REQUIRED]
        "friday": "13:00", -> UTC Time [Scenario #1][OPTIONAL]
        "date": "2023/07/29 14:00" -> UTC Time [Scenario #2][REQUIRED] 
      },
      hiddenOn: ["Saturday", "Sunday"], [Scenario #1][OPTIONAL]
      hideOnEnd: true, [OPTIONAL]
      hideParentOnEnd: true [OPTIONAL]
    } 
*/
var WDN = WDN || {};

if (typeof WDN.UTCCountdown === "undefined") {
  WDN.UTCCountdown = (function () {
    var UTCCountdown = function (config) {
      // Config
      this.config = config;

      // Now
      this.now = new Date();

      // Translations
      this.translations = WDN.Translations.countdown;

      // Output container
      this.outputContainer = document.querySelector("[data-countdown='" + config.id + "']");

      // Init
      this.init();
    };

    UTCCountdown.prototype.getCountdownToTime = function () {
      var dayToday = this.getTodaysDayName();

      if (dayToday === "Friday" && this.config.to.friday !== "") {
        return this.config.to.friday;
      }

      return this.config.to.default;
    };

    UTCCountdown.prototype.setTargetDate = function () {
      //### Handle 1st scenario:
      if (this.config.to.date) {
        // Input: "2023/7/28 13:00" - Split input so we separate date from time
        var formatSplit = this.config.to.date.split(" ");

        // 2023/7/28
        var date = formatSplit[0].split("/");

        // 13:00
        var time = formatSplit[1] ? formatSplit[1].split(":") : [];

        var year = parseInt(date[0]);
        var month = parseInt(date[1] - 1);
        var day = parseInt(date[2]);

        var hours = parseInt(time[0]) || 0;
        var minutes = parseInt(time[1]) || 0;
        var seconds = parseInt(time[2]) || 0;

        // Generate Date.UTC from given date
        this.targetUTC = Date.UTC(year, month, day, hours, minutes, seconds);

        return;
      }

      //### Handle 2nd scenario
      var toSplit = this.getCountdownToTime().split(":");
      this.targetUTC = new Date();
      this.targetUTC.setUTCHours(parseInt(toSplit[0]));
      this.targetUTC.setUTCMinutes(parseInt(toSplit[1]) || 0);
      this.targetUTC.setUTCSeconds(parseInt(toSplit[2]) || 0);
    };

    UTCCountdown.prototype.getNowUTC = function () {
      var now = new Date();
      return Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds());
    };

    UTCCountdown.prototype.getTimeDifference = function () {
      if (this.config.to.date) {
        return this.targetUTC - this.getNowUTC();
      }
      return this.targetUTC.getTime() - this.getNowUTC();
    };

    UTCCountdown.prototype.getTodaysDayName = function () {
      var Days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
      return Days[this.now.getUTCDay()];
    };

    UTCCountdown.prototype.allowedToStart = function () {
      var todaysDayName = this.getTodaysDayName();

      // If today's day is part of the hidden list
      if (this.config.hiddenOn.indexOf(todaysDayName) > -1) {
        return false;
      }

      // If time difference negative - do not start
      if (this.getTimeDifference() <= 0) return false;

      return true;
    };

    UTCCountdown.prototype.handleVisibility = function () {
      // Control output visibility
      if (this.config.hideOnEnd) {
        this.outputContainer.classList.add("hidden");
      }

      // Control output parent visibility
      if (this.config.hideParentOnEnd) {
        this.outputContainer.parentNode.classList.add("hidden");
      }
    };

    UTCCountdown.prototype.handleInterval = function () {
      if (this.timeDifference < 0) {
        this.stop();
        this.handleVisibility();
        return;
      }
      this.calculate();
      this.render();
    };

    UTCCountdown.prototype.start = function () {
      this.timer = setInterval(this.handleInterval.bind(this), 1000);
    };

    UTCCountdown.prototype.stop = function () {
      clearInterval(this.timer);
    };

    UTCCountdown.prototype.formatTime = function (time) {
      // if requested time is negative - set is as 0 instead
      time = time < 0 ? 0 : time;

      // converting time to string
      var stringTime = "" + time;

      // checking if is single digit number
      if (stringTime.length === 1) {
        stringTime = "0" + stringTime;
      }

      return stringTime;
    };

    UTCCountdown.prototype.calculate = function () {
      this.timeDifference = this.getTimeDifference();

      this.days = Math.floor(parseFloat(this.timeDifference / (1000 * 60 * 60 * 24)));
      this.hours = Math.floor((this.timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      this.minutes = Math.floor((this.timeDifference % (1000 * 60 * 60)) / (1000 * 60));
      this.seconds = Math.floor((this.timeDifference % (1000 * 60)) / 1000);

      this.days = this.formatTime(this.days);
      this.hours = this.formatTime(this.hours);
      this.minutes = this.formatTime(this.minutes);
      this.seconds = this.formatTime(this.seconds);
    };

    UTCCountdown.prototype.render = function () {
      this.outputContainer.innerHTML = this.getFormattedOutput();
    };

    UTCCountdown.prototype.getFormattedOutput = function () {
      var tk = this.translations;
      var output = [this.days + tk.days, this.hours + tk.hours, this.minutes + tk.minutes, this.seconds + tk.seconds];
      if (this.config.hideDays) {
        var output = [this.hours + tk.hours, this.minutes + tk.minutes, this.seconds + tk.seconds];
      }
      return output.join(tk.divider);
    };

    UTCCountdown.prototype.init = function () {
      this.setTargetDate();

      if (!this.allowedToStart()) {
        this.handleVisibility();
        return;
      }

      this.start();

      this.outputContainer.parentNode.classList.remove("hidden");
    };

    return UTCCountdown;
  })();

  document.dispatchEvent(new CustomEvent("UTCCountdown:loaded", { detail: {} }));
}
